import { useListBlocks } from "api/blocksApi";
import { PAGE_SIZE, SearchCategories } from "components/mediaLibrary/constants";

export default function useBlockParams(page: number, search: string, searchTerm: string, showArchived: boolean) {
  const getSearchTerm = ( value : string, selected : SearchCategories ): string | null => 
    value === SearchCategories.All || value === selected ? searchTerm! : null; 

  return useListBlocks(page, PAGE_SIZE, getSearchTerm(search, SearchCategories.Names)!, getSearchTerm(search, SearchCategories.Manuscript)!, getSearchTerm(search, SearchCategories.Tags)!, showArchived);
}